export const MF_URL = 'https://magnusfamous.com';
export const DF_URL = 'https://danielfilion.com';
export const CB_URL = 'https://ceasarsbag.com';
export const LC_URL = 'https://linecrm.winvasion.com';
